import React from 'react';
import CustomPopup from '.';
import FileUpload from '../loadImage/FileUpload';

const DialogPhoto = ({id, title, icon, children, onSave}) => {  
    
    return (
        <div>
            <CustomPopup title={title} id={id} icon={icon}>
                <FileUpload onSave={onSave} id={id}/>
            </CustomPopup>
        </div>
    );
}


export default DialogPhoto;
